import { CalendarDays, User } from 'lucide-react';
import { useParams } from 'react-router';

import { formatDate } from '../lib/date';
import { useGetNotice } from '../query/notice';
import { Card, CardContent, CardHeader } from './ui/card';

const NoticeCard = () => {
  const { noticeId } = useParams<{
    courseId: string;
    noticeId: string;
  }>();

  const { data: notice } = useGetNotice(noticeId, { enabled: !!noticeId });

  if (!notice) return <></>;

  return (
    <Card className="w-full shadow-lg border-0 bg-white">
      <CardHeader className="pb-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-3"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{notice.data?.title}</h2>
          </div>
        </div>

        <div className="flex items-center gap-6 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1">
              <User className="h-4 w-4" />
              <span className="font-medium">{notice.data?.creator.name}</span>
            </div>
          </div>

          <div className="flex items-center gap-1">
            <CalendarDays className="h-4 w-4" />
            <span>{formatDate(notice.data?.createdAt ?? '')}</span>
          </div>
        </div>
      </CardHeader>

      <CardContent className="pt-0">
        <div className="prose max-w-none">
          <div
            className="text-gray-800 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: notice.data?.noticeHTML ?? '' }}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default NoticeCard;
